import React, { SetStateAction } from "react";
import { MdDelete } from "react-icons/md";

interface IHistory {
  arr: string[];
  setArr: React.Dispatch<SetStateAction<string[]>>;
}

const History = ({ arr, setArr }: IHistory) => {
  const handleDeleteHistory = () => {
    localStorage.setItem("history", JSON.stringify([]));
    setArr([]);
  };

  if (!arr || arr.length === 0) {
    return <p>Nothing in History</p>;
  }

  return (
    <div className="history-container">
      {arr.map((item: string, index: number) => (
        <p key={index}>{item}</p>
      ))}
      <div className="trash" onClick={handleDeleteHistory}>
        <p>DELETE</p>
        <MdDelete />
      </div>
    </div>
  );
};

export default History;
